import React from "react";
import { Button } from "react-bootstrap";
import { UiCardTitle } from "../../../components/common/UiCardTitle";
import { UiContentCol, UiContentWr } from "../../../components/common/UiPageElements";
import { UiCol, UiRowContainer, UiSingleRow } from "../../../components/grid-container/GridContainer";
import progressImage from '../../../../../styles/img/knowledge-progress.jpg';
import volvoLogo from '../../../../../styles/img/volvo-logo-round.png';
import bannerPerson from '../../../../../styles/img/knw-banner-pers.png';

export const KnowledgeProgressV2 = () => {
    return (
        <>
            <UiContentWr>
                <UiRowContainer fluid="fluid" className="sb-knw-progress-section">
                    <UiCol lg="12">
                        <UiContentCol>
                            <div className="sb-knw-progress-sec">
                                <UiSingleRow>
                                    <UiCardTitle title="Your Progress" underlined={true} />
                                    <UiCol lg="2">
                                        <div className="sb-knw-progress-sec__quiz-box">
                                            <div>
                                                <h4>18/50</h4>
                                                <p>Quizzes Taken</p>
                                            </div>
                                        </div>
                                    </UiCol>
                                    <UiCol lg="3">
                                        <div className="sb-knw-progress-sec__quiz-box">
                                            <div>
                                                <h4>12/15</h4>
                                                <p>Courses Completed</p>
                                            </div>
                                        </div>
                                    </UiCol>
                                    <UiCol lg="2">
                                        <div className="sb-knw-progress-sec__quiz-box">
                                            <div>
                                                <h4>18/50</h4>
                                                <p>Badges Earned</p>
                                            </div>
                                        </div>
                                    </UiCol>
                                    <UiCol lg="5" className="sb-knw-cont-card">
                                        <div className='sb-knw-img-cont-card-1'>
                                            <img src={volvoLogo} />
                                            <div>
                                                <h4>Volvo Special</h4>
                                                <p>Multiple Categories</p>
                                            </div>
                                        </div>

                                        <div className='sb-knw-img-cont-card-2'>
                                            <img src={bannerPerson} />
                                            <div>
                                                <h4>Jamie Vardy</h4>
                                                <p>Helpful Knowledge!</p>
                                            </div>
                                        </div>
                                    </UiCol>


                                </UiSingleRow>
                            </div>
                        </UiContentCol>
                    </UiCol>
                    <UiCol lg="6" className="mt-4">
                        <UiContentCol>
                            <div className="sb-knw-progress-sec__desc">
                                <div className="sb-progress-desc">
                                    <h3>Earn 500 points!</h3>
                                    <p>Discover the new Volvo range today and pick up quick and easy points!</p>
                                    <Button to="" className="sb-primary-btn--38">Start !</Button>
                                </div>
                                <img src={volvoLogo} />
                            </div>
                        </UiContentCol>
                    </UiCol>
                    <UiCol lg="3" className="mt-4">
                        <img src={progressImage} className="sb-knw-progress-sec__progress_img" />
                    </UiCol>
                    <UiCol lg="3" className="mt-4">
                        <img src={progressImage} className="sb-knw-progress-sec__progress_img" />
                    </UiCol>
                </UiRowContainer>
            </UiContentWr>
        </>
    )
}
